import dynamic from 'next/dynamic';
import {Component} from 'react';

import PortalLayout from '../../components/portal/layout/portal-layout.component';

const ApiKeysComponent = dynamic(() =>
    import('../../components/portal/api-keys/api-keys.component').then(m => ({
        default: m.ApiKeysComponent,
    })),
);

// See pages/portal/billing.tsx for the getStaticProps rationale —
// _app.tsx's init() requires pageProps.url to bootstrap LoginService.
export async function getStaticProps() {
    return {props: {url: '/portal/api-keys'}};
}

/** Portal API keys management page (`/portal/api-keys`). developer-api §14 E1. */
export default class ApiKeysPage extends Component {
    render() {
        return (
            <PortalLayout
                activePath="/portal/api-keys"
                breadcrumbs={[
                    {label: 'Portal', href: '/portal'},
                    {label: 'Developer'},
                    {label: 'API keys'},
                ]}
            >
                <ApiKeysComponent {...this.props} />
            </PortalLayout>
        );
    }
}
